module.exports = __webpack_public_path__ + "static/img/012酒庄官网3.6ec5780.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/012酒庄官网3.jpg
// module id = /mDx
// module chunks = 0